const RolSelect = (props) => {
  const handleChange = (e) => {
    props.setPermissionsSave([])
    const selectedRole =
      props.roles.find((rol) => String(rol.Id) === String(e.target.value)) || null;
    props.setRole(selectedRole);
  };
  return (
    <div className="w-full py-4 sm:p-4 space-y-4">
      <h1 className="text-2xl font-bold">Permisos</h1>
      <div className="w-full max-w-sm">
        <label className="block mb-2 text-sm font-medium text-gray-700">
          Rol
        </label>
        <select
          className="w-full rounded-lg border border-gray-300 px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
          value={props.role?.Id ?? ''}
          onChange={handleChange}
        >
          <option value={''}>Seleccione un rol</option>
          {props.roles.map((rol) => (
            <option key={rol.Id} value={rol.Id}>
              {rol.Name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default RolSelect;
